import { render, staticRenderFns } from "./CentroOncologiaComponente.vue?vue&type=template&id=4ba57c9a&scoped=true"
import script from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
export * from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroOncologiaComponente.vue?vue&type=style&index=0&id=4ba57c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba57c9a",
  null
  
)

export default component.exports